import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { useAuthStore } from '../../../store/authStore';
import { CompanyAdminPanel } from '../CompanyAdminPanel';
import { WorksiteDetailScreen } from './WorksiteDetailScreen';
import '../SettingsPage.css';

/**
 * `/settings/worksites/:worksiteId` — 사업장 상세 라우트 (2026-09-14 · v3).
 *
 * ★ 통합설정 좌측 메뉴(CompanyAdminPanel)는 그대로 서고 오른쪽 본문만 상세 화면으로 바뀐다(시안의 「통합설정 좌측 메뉴 자리」).
 *   메뉴에서 다른 칸을 누르면 `/settings?pane=<칸>` 으로 돌아간다.
 * ★ 가드는 `/settings` 와 같다 — 라우트에 RoleGuard 없이 **역할로** 가른다(SettingsPage 머리말). 관리자가 아니면 통합설정
 *   안내 화면으로 보낸다. 최종 판정은 서버다(사업장 쓰기는 근태 관리 권한).
 */
export function WorksiteDetailRoute(): JSX.Element {
  const { worksiteId = '' } = useParams<{ worksiteId: string }>();
  const navigate = useNavigate();
  const role = useAuthStore((s) => s.user?.role);
  const isAdmin = role === 'ADMIN' || role === 'SYSTEM_ADMIN';
  if (!isAdmin) return <Navigate to="/settings" replace />;

  return (
    <div className="settings-page">
      <div className="settings-body scrollbar-thin">
        <div className="settings-content settings-content--wide">
          <CompanyAdminPanel
            pane="worksite"
            onPaneSelect={(id) => navigate(`/settings?pane=${id}`)}
            body={<WorksiteDetailScreen key={worksiteId} worksiteId={worksiteId} />}
          />
        </div>
      </div>
    </div>
  );
}

export default WorksiteDetailRoute;
